/**
 * Client-side AML result grouping (mirrors backend amlResultCategories.js).
 */

export const AML_CATEGORY_TABS = [
  { key: 'pep', label: 'PEP', badgeClass: 'bg-red-100 text-red-800 border-red-200' },
  { key: 'adverseMedia', label: 'Adverse Media', badgeClass: 'bg-amber-100 text-amber-900 border-amber-200' },
  { key: 'associates', label: 'Associates', badgeClass: 'bg-blue-100 text-blue-800 border-blue-200' },
  { key: 'sanctions', label: 'Sanctions', badgeClass: 'bg-purple-100 text-purple-800 border-purple-200' },
  { key: 'other', label: 'Other', badgeClass: 'bg-gray-100 text-gray-800 border-gray-200' }
]

export function classifyCategoryBucket(match) {
  const cat = String(match?.riskCategory || '').trim()
  const upper = cat.toUpperCase()
  if (/^ASSOCIATE/.test(upper)) return 'associates'
  if (/ADVERSE|MEDIA/.test(upper)) return 'adverseMedia'
  if (/SANCTION/.test(upper)) return 'sanctions'
  if (/^(PEP|RCA|SIP|SIE)\b/.test(upper) || upper === 'PEP') return 'pep'
  if (/PEP/.test(upper)) return 'pep'
  if (match?.sanctionsMatch === true) return 'sanctions'
  if (match?.pepMatch === true) return 'pep'
  return 'other'
}

export function groupResultsByCategory(matches) {
  const groups = { pep: [], adverseMedia: [], sanctions: [], associates: [], other: [] }
  for (const m of matches || []) {
    groups[classifyCategoryBucket(m)].push(m)
  }
  return groups
}

/** Prefer API grouping; otherwise derive from flat results. */
export function resolveResultsByCategory(results, resultsByCategory) {
  if (resultsByCategory && typeof resultsByCategory === 'object') {
    return {
      pep: resultsByCategory.pep || [],
      adverseMedia: resultsByCategory.adverseMedia || [],
      sanctions: resultsByCategory.sanctions || [],
      associates: resultsByCategory.associates || [],
      other: resultsByCategory.other || []
    }
  }
  return groupResultsByCategory(results || [])
}

/** Flat list in tab order so list index matches category tabs. */
export function flattenResultsByCategory(results, resultsByCategory) {
  const grouped = resolveResultsByCategory(results, resultsByCategory)
  return AML_CATEGORY_TABS.flatMap((t) => grouped[t.key] || [])
}

export function formatThreatLevel(threatLevel) {
  const s = String(threatLevel || '')
  if (!s) return '—'
  return s
    .replace(/MATCH_REVIEW_REQUIRED/gi, 'Match — review required')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

export function normalizeProfileDob(dob) {
  if (!dob) return ''
  const s = String(dob).trim()
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10)
  const slash = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/)
  if (slash) {
    const [, d, m, y] = slash
    return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`
  }
  return s
}
